import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./ItemHp.scss";
import Strings from "../../translations/translations";
import { saveGoBackPage } from "../../utils/history";
import LazyLoadBackgroundImage from "components/LazyLoadBackgroundImage/LazyLoadBackgroundImage";
import { LazyLoadImage } from "react-lazy-load-image-component";

export class ItemHp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: this.props.size,
    };
  }

  static defaultPropTypes = {
    size: 0,
  };

  render() {
    const {
      brand,
      youtubeId,
      background,
      logo,
      type,
      title,
      size,
      id,
    } = this.props;
    const courseTranslation = Strings("course");
    const newsTranslation = Strings("new");
    const height = "calc(14rem + (" + size + " * 16rem))";

    switch (type) {
      case "article":
        return (
          <Link
            to={{
              pathname: "/news/" + id,
              state: { transitionName: "zoom_in" },
            }}
          >
            <LazyLoadBackgroundImage height={height} src={background}>
              <div className="item_hp">
                {logo ? (
                  <LazyLoadImage
                    className="item_logo"
                    src={logo}
                    alt=""
                  ></LazyLoadImage>
                ) : (
                  <div className="item_brand">{brand.name}</div>
                )}
                <div className="item_text">
                  <div className="item_type">{newsTranslation}</div>
                  <div className="item_title">{title}</div>
                </div>
              </div>
            </LazyLoadBackgroundImage>
          </Link>
        );

      case "course":
        return (
          <Link
            to={{
              pathname: "/formations/" + id,
              state: {
                transitionName: "slide_in",
              },
            }}
            onClick={() => saveGoBackPage(this.props.location.pathname)}
          >
            <LazyLoadBackgroundImage height={height} src={background}>
              <div className="item_hp">
                {logo ? (
                  <LazyLoadImage
                    className="item_logo"
                    src={logo}
                    alt=""
                  ></LazyLoadImage>
                ) : (
                  <div className="item_brand">{brand.name}</div>
                )}

                <div className="item_text">
                  <div className="item_type">{courseTranslation}</div>
                  <div className="item_title">{title}</div>
                </div>
              </div>
            </LazyLoadBackgroundImage>
          </Link>
        );

      case "video":
        return (
          <Link
            to={{
              pathname: "/brands/videos/" + brand.id + "/watch=" + youtubeId,
              state: {
                transitionName: "slide_in",
                fromHomepage: "true",
                id: id,
              },
            }}
          >
            <LazyLoadBackgroundImage height={height} src={background}>
              <div className="item_hp">
                {logo ? (
                  <LazyLoadImage
                    className="item_logo"
                    src={logo}
                    alt=""
                  ></LazyLoadImage>
                ) : (
                  <div className="item_brand">{brand.name}</div>
                )}
                <div className="item_text">
                  <div className="item_type">{type}</div>
                  <div className="item_title">{title}</div>
                </div>
              </div>
            </LazyLoadBackgroundImage>
          </Link>
        );
      default:
        return null;
    }
  }
}

export default withRouter(ItemHp);
